import * as xlsx from "xlsx";
const $inject = ['$q', '$scope', '$routeParams', 'Upload', 'dataService', 'lbaLeafletMapService'];

function dateTimeString(int) {
  if (String(int).length === 1) return '0' + int;

  return String(int);
}

const lbaFileUploaderCtrl = function ($q, $scope, $routeParams, Upload, dataService, lbaLeafletMapService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.importFile = importFile;
  vm.blobUrl = blobUrl;
  vm.progressPercentage = 0;
  vm.uploadSuccess = false;
  vm.uploadFailure = false;
  vm.uploading = false;
  let zeroAddresses = [];
  vm.filename = '';
  vm.errorText = '';
  vm.deleteImage = deleteImage;
  
  vm.pointsOfInterestColumns = [
    {
      name: 'DebtorIdentifier',
      dataAt: 'DebtorIdentifier',
    },
    {
      name: 'Title',
      dataAt: 'Title',
    },
    {
      name: 'Description',
      dataAt: 'Description',
    },
    {
      name: 'Address',
      dataAt: 'Address',
    },
    {
      name: 'Latitude',
      dataAt: 'Latitude',
    },
    {
      name: 'Longitude',
      dataAt: 'Longitude',
    },
  ];

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function getPosition(address, i) {
    var defer = $q.defer();
    lbaLeafletMapService.getPosByAddress(address, i)
      .then((data) => {
        defer.resolve(data);
      })
      .catch((status) => {
        if (status == 'ZERO_RESULTS') {
          defer.resolve();
          zeroAddresses.push(i + 2);
          console.log(`Problem recognising address for row ${i + 2} -`, address);
        }
        else {
          defer.reject(status);
          console.log('Error getting position', status);
        }    
      });
    return defer.promise;
  }

  vm.upload = function (file) {
    vm.uploadFailure = false;

    if (!file) {
      vm.uploadFailure = true;
      return false;
    }
    Upload.upload({
      url: `${endPointUrl}/api/Upload/${vm.settings.fileContainer}?filename=${vm.filename}`,
      data: { file: file }
    }).then(function (resp) {
      vm.uploadSuccess = true;
      vm.uploading = false;
      if (!vm.settings.excludeFromPost) {
        vm.data = resp.data;
      } else {
        vm.filename = resp.data;
      }
    }, function (error) {
      vm.uploading = false;
      vm.uploadSuccess = false;
      vm.uploadFailure = true;
      console.log('Error status: ' + error.status);
    }, function (evt) {
      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  function importFile(file) {
    vm.uploading = false;
    vm.uploadSuccess = false;
    vm.uploadFailure = false;

    if (!file) {
      return;
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let fileName;

    if (vm.settings.fileNameFormat) {
      let fileNameDate = new Date();

      fileName = dateTimeString(fileNameDate.getFullYear());
      fileName += dateTimeString(fileNameDate.getMonth() + 1);
      fileName += dateTimeString(fileNameDate.getDate()) + '_';
      fileName += dateTimeString(fileNameDate.getHours());
      fileName += dateTimeString(fileNameDate.getMinutes());

    } else {
      fileName = new Date() + '';
      fileName = fileName.replace(/[^\/\d]/g, '');
    }

    if (vm.settings.fileNamePrefixProperty) {
      fileName = dataService.data.activeItem[vm.settings.fileNamePrefixProperty] + '_' + fileName;
    }

    if (vm.settings.fileNameSuffix) {
      fileName = fileName + vm.settings.fileNameSuffix;
    }

    fileName += fileExtension;
    vm.filename = fileName;

    if (vm.settings.dataAt == 'PointsOfInterestFile') {
      var reader = new FileReader();
      let output = [];
      reader.onload = function (e) {
        vm.uploading = true;
        zeroAddresses = [];
        try {
          var data = e.target.result;
          var wb = xlsx.read(data, {
            type: "binary",
          });
          var getPositionPromises = [];
          wb.SheetNames.forEach((sheetName) => {
            output = xlsx.utils
              .sheet_to_json(wb.Sheets[sheetName])
              .map((item, i) => {
                const obj = {};
                vm.pointsOfInterestColumns.forEach((col) => {
                  if (col.name == 'Latitude' && item[col.name] == null) {
                    var promise = getPosition(item['Address'], i).then((position) => {
                      _.set(obj, 'Latitude', position ? position.lat : null);
                      _.set(obj, 'Longitude', position ? position.long : null);
                    });
                    getPositionPromises.push(promise);
                  } else {
                    _.set(obj, col.dataAt, item[col.name] || null);
                  }
                });
                return obj;
              });
          });

          $q.all(getPositionPromises).then(() => {
            if (zeroAddresses.length > 0) {
              vm.uploading = false;
              vm.uploadFailure = true;
              vm.errorText = zeroAddresses.length > 1 ? `Unrecognised addresses. Please check the following rows: ${zeroAddresses}` 
              : `Unrecognised address. Please check row ${zeroAddresses}`;
            } else {
              var ws = xlsx.utils.json_to_sheet(output);
              const wb = xlsx.utils.book_new();
              xlsx.utils.book_append_sheet(wb, ws, 'points-of-interest');
              var content = xlsx.write(wb, { type: 'array' });
              var newFile = new File([content], vm.filename, { type: "plain/xlsx" });
              vm.upload(newFile);
              }
          }, function (error) {
            vm.uploading = false;
            vm.uploadFailure = true;
            console.log(error);
          });
        } catch (e) {
          console.warn(e);
        }
      }

      reader.onerror = function (ex) {
        console.warn(ex);
      };

      reader.readAsBinaryString(file);
    } else {
      vm.upload(file);
    }
  }

  function deleteImage() {
    vm.data = null;
  }
};

lbaFileUploaderCtrl.$inject = $inject;

export default lbaFileUploaderCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaFileUploader/lbaFileUploaderCtrl.js